import { useRef } from 'react'

/*
 * Ungespeicherte Aenderungen erkennen, wo das Formular von Hand gefuehrt wird
 * (also ohne react-hook-form, das dafuer `formState.isDirty` mitbringt).
 *
 * Verglichen wird gegen den ersten Stand, der ueberhaupt da war: Die Fenster
 * laden ihre Werte nach, `values` ist im ersten Durchlauf noch leer. Genommen
 * wird deshalb der erste Wert, der nicht null/undefined ist.
 *
 * `resetKey` setzt den Vergleichsstand zurueck — noetig, wo dasselbe Fenster
 * nacheinander verschiedene Datensaetze zeigt (dann die ID hereingeben) oder
 * wo nach dem Speichern weitergearbeitet wird.
 *
 * Dateien (File-Objekte) fallen beim Vergleich unter den Tisch — wo Anhaenge
 * mitzaehlen sollen, gehoert ihre Anzahl mit in den uebergebenen Wert.
 */
export default function useIsDirty(values, resetKey) {
	const initial = useRef(null)
	const key = useRef(resetKey)

	if (key.current !== resetKey) {
		key.current = resetKey
		initial.current = null
	}

	const current = values === null || values === undefined ? null : JSON.stringify(values)

	if (initial.current === null && current !== null) initial.current = current
	if (current === null || initial.current === null) return false

	return current !== initial.current
}
